
import { Component, Watch, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VWrapper from '@/components/shared/VWrapper.vue';
import PosSyncTable from '@/components/posSync/PosSyncTable.vue';
import Filter from '@/interfaces/api/Filter';
import { PosSync as PosSyncModel } from '@/interfaces/models/PosSync';
import { Venue } from '@/interfaces/models/Venue';
import { Page } from '@/interfaces/api/Page';

const venue = namespace('venue');
const posSync = namespace('posSync');
const app = namespace('app');

@Component({
  components: { VWrapper, PosSyncTable },
})
export default class PosSync extends Vue {
  @posSync.Action('setFilter') public setFilter!: (filter: Filter) => void;
  @posSync.Action('fetch') public getItems!: any;

  @posSync.State((state) => state.pagination.total) public total!: number;
  @posSync.State('filter') public filter!: Filter;
  @posSync.State('items') public items!: PosSyncModel[];
  @venue.State('active') public venue!: Venue;
  @app.State('venues') public venues!: Venue[];

  public async created() {
    if (!this.venue) {
      this.$startLoading('venue');
    }

    if (this.venue?._id) {
      await this.fetch();
    }
  }

  public async fetch(page?: Page) {
    const filter = { venue: this.venue._id, page: page || this.$route.query.page || 1, limit: 10 };

    this.$startLoading('posSync');
    this.setFilter(filter);
    await this.getItems(filter);
    this.$stopLoading('posSync');
  }

  @Watch('venue')
  public async onVenueChange() {
    if (this.venue && this.venue._id) {
      await this.fetch();
    }
  }
}
